/**
 * The status line under a sending message with images (styles in
 * styles/image.css, ns-upload).
 */
import { useT } from '../i18n';
import { cancelPending, type PendingMessage } from '../store/messages';

/**
 * What a sending message's images are doing, honestly: optimizing and
 * uploading can be cancelled; once every byte is up the server is
 * processing them and the message is about to appear, so no Cancel then.
 */
export function UploadStatus({ p }: { p: PendingMessage }) {
  const { t } = useT();
  const pct = Math.round((p.progress ?? 0) * 100);
  const phase = p.phase === 'uploading' && pct >= 100 ? 'processing' : (p.phase ?? 'uploading');
  return (
    <div className="ns-upload" role="status" data-phase={phase}>
      <span className="ns-upload-t">
        {phase === 'optimizing'
          ? t('img.optimizing', { n: pct })
          : phase === 'uploading'
            ? t('img.uploading', { n: pct })
            : t('img.processing')}
      </span>
      <span className="ns-prog" aria-hidden="true">
        <i style={{ width: `${phase === 'processing' ? 100 : pct}%` }} />
      </span>
      {phase !== 'processing' ? (
        <button type="button" onClick={() => cancelPending(p.channelId, p.nonce)}>
          {t('c.cancel')}
        </button>
      ) : null}
    </div>
  );
}
